<template>
  <div class="wrapper">

    <div class="header_wrapper">
      <v-toolbar
        class="fixed_toolbar"
        color="primary"
        dark
      >
        <v-btn
          @click="routerBack"
          style="position: absolute"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer />
        <v-toolbar-title>{{ childName }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="clickPost"
          :loading="btnLoading"
          class="no-background-hover"
          style="position: absolute;　right: 20px;"
          icon
        >
          {{ t('childrenGrowth.save') }}
        </v-btn>
      </v-toolbar>
    </div>

    <div class="content_wrapper">
      <div
        v-if="fetchLoading"
        class="d-flex align-center"
      >
        <vue-loading
          :active="fetchLoading"
          loader="bars"
          color="#EE6090"
          :size="{ width: '30px', height: '30px' }"
        ></vue-loading>
      </div>

      <v-form
        ref="post_childrenbasic_form"
        class="form_wrapper px-2 py-3"
        v-if="!fetchLoading && answers.length"
      >

        <div
          v-for="(f, index) in formats"
          :key="f.key"
        >
          <children-field
            :format="f"
            :answers="answers"
            :index="index"
            @inputValue="inputValue"
          />

        </div>

      </v-form>
    </div>

  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import { Toast } from '@/service/SweetAlert';
import { t, locale } from '@/i18n';
dayjs.locale(locale);

import { childrenModule } from '@/store/entityModules/children';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import ChildrenField from '@/components/organisms/ChildrenField.vue';

import { VForm } from '@/model/Vuetify/VForm';
import { ChildInfoFormat } from 'chaild-entity/src/component/nursery/child/types';

interface DataType {
  childId: number;
  childName: string;
  fetchLoading: boolean;
  btnLoading: boolean;
  answers: Array<{
    key: string;
    value: any | null;
  }>;
}

export default defineComponent({

  components: {
    'vue-loading': Loading,
    ChildrenField,
  },

  computed: {
    form(): VForm {
      return (this.$refs as any).post_childrencondition_form;
    },
    formats() {
      return childrenModule.healthInfoFormats;
    },
  },

  data: (): DataType =>({
    childId: NaN,
    childName: '',
    fetchLoading: false,
    btnLoading: false,
    answers: [],
  }),

  methods: {
    t,
    routerBack() {
      this.$router.replace('/children');
    },
    async clickPost() {
      if (this.form.validate()) {
        this.btnLoading = true;
        try {
          let answers = this.answers;
          answers = answers.map((a) => {
            if (Array.isArray(a.value)) {
              a.value = a.value.filter(Boolean);
            }
            return a;
          });
          const response = await childrenModule.postChildrenInfo({
            childId: String(this.childId),
            answers,
          });
          this.btnLoading = false;
          Toast.fire({
            icon: 'success',
            title: t('childrenGrowth.successMessage'),
          });
        } catch (error) {
          this.btnLoading = false;
        }
      }
    },
    inputValue({ format, value }: {
      format: ChildInfoFormat;
      value: any;
    }) {
      this.answers.map((a) => {
        if (a.key === format.key) {
          a.value = value;
        }
      });
    },
    initInfo() {
      if (childrenModule.childInfo) {
        childrenModule.childInfo.healthInfo.map((info) => {
          this.answers.map((answer) => {
            if (answer.key === info.key) {
              answer.value = info.value;
            }
          });
        });
      }
    },
  },

  async mounted() {
    if (typeof this.$route.query.childName === 'string') {
      this.childName = this.$route.query.childName;
    }
    if (typeof this.$route.query.childId === 'string') {
      this.childId = Number(this.$route.query.childId);
      this.fetchLoading = true;
      await Promise.all([
        childrenModule.fetchChildrenInfoFormat(),
        childrenModule.fetchChildrenInfo({
          childId: String(this.childId),
        }),
      ]);
      this.fetchLoading = false;
      for (const f of childrenModule.healthInfoFormats) {
        this.answers.push({
          key: f.key,
          value: null,
        });
      }
      this.initInfo();
    } else {
      this.routerBack();
    }
  },

});
</script>
<style lang="scss" scoped>
.wrapper {
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
    margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
  }

  .header_wrapper {
    height: 181px;
    width: 100%;
    position: fixed;
    z-index: 1;

    .outline {
      border: 1px solid rgb(var(--v-theme-primary));
    }
    @supports (bottom: env(safe-area-inset-bottom)) {
      padding-top: env(safe-area-inset-top);
    }
  }

  .content_wrapper {
    min-height: calc(100% - 56px);
    margin: 56px 0 0px;
    overflow-y: hidden;
  }
}
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
</style>
